
import { useTheme } from "@/contexts/ThemeContext";
import { Button } from "@/components/ui/button";
import { Moon, Sun } from "lucide-react";

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const toggleTheme = () => {
    // Fix the double-click issue by properly cycling through themes
    if (theme === "light") {
      setTheme("dark");
    } else if (theme === "dark") {
      setTheme("light"); // Changed from "system" to "light"
    } else {
      setTheme("light");
    }
  };

  return (
    <Button variant="outline" size="icon" onClick={toggleTheme} className="relative shrink-0">
      <Sun
        className="h-[1.45rem] w-[1.45rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0"
      />
      <Moon
        className="absolute h-[1.45rem] w-[1.45rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100"
      />
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
}
